module.exports = __webpack_public_path__ + "static/media/secondaire.8df274c6.png";